export const CONDITION_TYPES = {
  // NUMERIC
  numeric_range: {
    label: 'Between',
    dataTypes: ['number'],
    component: 'NumericRangeCondition',
    defaults: { min: 0, max: 1, minInclusive: true, maxInclusive: false },
    evaluate(value, { min, max, minInclusive = true, maxInclusive = false }) {
      const num = parseFloat(value)
      if (isNaN(num)) return false
      const minOk = minInclusive ? num >= min : num > min
      const maxOk = maxInclusive ? num <= max : num < max
      return minOk && maxOk
    }
  },

  numeric_gt: {
    label: 'Greater Than',
    dataTypes: ['number'],
    component: 'NumericThresholdCondition',
    defaults: { threshold: 0, inclusive: false },
    evaluate(value, { threshold, inclusive = false }) {
      const num = parseFloat(value)
      if (isNaN(num)) return false
      return inclusive ? num >= threshold : num > threshold
    }
  },

  numeric_lt: {
    label: 'Less Than',
    dataTypes: ['number'],
    component: 'NumericThresholdCondition',
    defaults: { threshold: 0, inclusive: false },
    evaluate(value, { threshold, inclusive = false }) {
      const num = parseFloat(value)
      if (isNaN(num)) return false
      return inclusive ? num <= threshold : num < threshold
    }
  },

  numeric_eq: {
    label: 'Equals',
    dataTypes: ['number'],
    component: 'NumericEqualsCondition',
    defaults: { value: 0 },
    evaluate(value, config) {
      return parseFloat(value) === parseFloat(config.value)
    }
  },

  // DATETIME
  date_before: {
    label: 'Before Date',
    dataTypes: ['datetime'],
    component: 'DatePickerCondition',
    defaults: { date: null },
    evaluate(value, { date }) {
      if (!value || !date) return false
      return new Date(value) < new Date(date)
    }
  },

  date_after: {
    label: 'After Date',
    dataTypes: ['datetime'],
    component: 'DatePickerCondition',
    defaults: { date: null },
    evaluate(value, { date }) {
      if (!value || !date) return false
      return new Date(value) > new Date(date)
    }
  },

  date_between: {
    label: 'Between Dates',
    dataTypes: ['datetime'],
    component: 'DateRangeCondition',
    defaults: { start: null, end: null },
    evaluate(value, { start, end }) {
      if (!value || !start || !end) return false
      const d = new Date(value)
      return d >= new Date(start) && d <= new Date(end)
    }
  },

  date_older_than: {
    label: 'Older Than',
    dataTypes: ['datetime'],
    component: 'DateDurationCondition',
    defaults: { amount: 7, unit: 'days' },
    evaluate(value, { amount, unit }) {
      if (!value) return false
      const ms = { minutes: 60000, hours: 3600000, days: 86400000, weeks: 604800000, months: 2592000000, years: 31536000000 }
      const threshold = new Date(Date.now() - (amount * ms[unit]))
      return new Date(value) < threshold
    }
  },

  date_within: {
    label: 'Within Last',
    dataTypes: ['datetime'],
    component: 'DateDurationCondition',
    defaults: { amount: 7, unit: 'days' },
    evaluate(value, { amount, unit }) {
      if (!value) return false
      const ms = { minutes: 60000, hours: 3600000, days: 86400000, weeks: 604800000, months: 2592000000, years: 31536000000 }
      const threshold = new Date(Date.now() - (amount * ms[unit]))
      return new Date(value) >= threshold
    }
  },

  date_is_today: {
    label: 'Is Today',
    dataTypes: ['datetime'],
    component: null,
    defaults: {},
    evaluate(value) {
      if (!value) return false
      return new Date(value).toDateString() === new Date().toDateString()
    }
  },

  date_is_past: {
    label: 'Is In Past',
    dataTypes: ['datetime'],
    component: null,
    defaults: {},
    evaluate(value) {
      if (!value) return false
      return new Date(value) < new Date()
    }
  },

  date_is_future: {
    label: 'Is In Future',
    dataTypes: ['datetime'],
    component: null,
    defaults: {},
    evaluate(value) {
      if (!value) return false
      return new Date(value) > new Date()
    }
  },

  // UNIVERSAL
  is_empty: {
    label: 'Is Empty',
    dataTypes: ['number', 'string', 'datetime', 'boolean'],
    component: null,
    defaults: {},
    evaluate(value) {
      return value === null || value === undefined || value === ''
    }
  },

  is_not_empty: {
    label: 'Has Value',
    dataTypes: ['number', 'string', 'datetime', 'boolean'],
    component: null,
    defaults: {},
    evaluate(value) {
      return value !== null && value !== undefined && value !== ''
    }
  },

  always: {
    label: 'Always',
    dataTypes: ['number', 'string', 'datetime', 'boolean'],
    component: null,
    defaults: {},
    evaluate() {
      return true
    }
  }
}

export function getConditionsForDataType(dataType) {
  return Object.entries(CONDITION_TYPES)
    .filter(([, config]) => config.dataTypes.includes(dataType))
    .map(([key, config]) => ({ key, ...config }))
}
